// src/components/TipsModal.jsx
import React, { useState, useEffect } from 'react';
import { getRandomTip, getNextTip, getPreviousTip } from '../data/tips';

export default function TipsModal({ onClose }) {
  const [currentTip, setCurrentTip] = useState(null);

  useEffect(() => {
    // Load random tip on mount
    setCurrentTip(getRandomTip());
  }, []);

  const handleNext = () => {
    setCurrentTip(getNextTip(currentTip.id));
  };

  const handlePrevious = () => {
    setCurrentTip(getPreviousTip(currentTip.id));
  };

  const handleRandom = () => {
    setCurrentTip(getRandomTip());
  };

  if (!currentTip) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      zIndex: 1000
    }}>
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '30px',
        maxWidth: '600px',
        width: '100%',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3)',
        position: 'relative'
      }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <span style={{ fontSize: '48px' }}>{currentTip.icon}</span>
          <h3 style={{ 
            fontSize: '24px', 
            fontWeight: 'bold', 
            margin: '10px 0 5px 0', 
            color: '#d97706' 
          }}>
            {currentTip.title}
          </h3>
          
        </div>

        {/* Tip Content */}
        <p style={{ 
          fontSize: '16px', 
          lineHeight: '1.6', 
          color: '#374151', 
          marginBottom: '25px',
          minHeight: '120px'
        }}>
          {currentTip.tip}
        </p>

        {/* Navigation Buttons */}
        <div style={{ 
          display: 'flex', 
          gap: '10px', 
          marginBottom: '20px',
          justifyContent: 'center'
        }}>
          <button
            onClick={handlePrevious}
            style={{
              background: '#f3f4f6',
              color: '#374151',
              padding: '10px 20px',
              borderRadius: '8px',
              border: 'none',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            ← Previous
          </button>
          
          <button
            onClick={handleRandom}
            style={{
              background: '#fef3c7',
              color: '#92400e',
              padding: '10px 20px',
              borderRadius: '8px',
              border: '2px solid #fcd34d',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            🎲 Random Tip
          </button>

          <button
            onClick={handleNext}
            style={{
              background: '#f3f4f6',
              color: '#374151',
              padding: '10px 20px',
              borderRadius: '8px',
              border: 'none',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            Next →
          </button>
        </div>

        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            width: '100%',
            background: '#d97706',
            color: 'white',
            padding: '12px',
            borderRadius: '8px',
            border: 'none',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: '500'
          }}
        >
          Got it!
        </button>
      </div>
    </div>
  );
}
